/**
 * ## Embed usage for Xenial
 *
 * @module src/embed
 */

"use strict";

const defaults = require("./configgla.json");
const conf = require("../../config");

/** init
 */
const configure = (kd) => {
  kd.localstore.data.offline = false;
  kd.localstore.data.credentials.user_id = "10";
  kd.localstore.data.credentials.room = "state";

  return true;
};

const getXConfig = (kd, options, callback) => {
  if (
    !kd.xenial.hasOwnProperty("floorPlanDocumentID") ||
    !kd.xenial.floorPlanDocumentID
  ) {
    // no doc ID provided, use GL API and then recursively load getXConfig again with doc ID
    const headers = {
      "Content-Type": "application/json",
    };
    const postData = {
      dmEnvironmentURL: kd.xenial.dmEnvironmentURL,
      accessToken: kd.xenial.accessToken,
    };
    $.ajax({
      url: `${conf.vars.API_ROOT}/dm`,
      type: "POST",
      contentType: "application/json",
      headers,
      data: JSON.stringify(postData),
      success: (result) => {
        kd.xenial.floorPlanDocumentID = result[0]._id;
        const pushState = `/?usage=${kd.usage}&accessToken=${kd.xenial.accessToken}&floorPlanDocumentID=${kd.xenial.floorPlanDocumentID}&dmEnvironmentURL=${kd.xenial.dmEnvironmentURL}`;
        history.pushState(null, "", pushState);
        getXConfig(kd, options, callback);
      },
      error: (jqXHR, textStatus, errorThrown) => {
        callback(null, { status: "error", errorThrown });
      },
      timeout: 10000,
    });
  } else {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Company-Id": kd.xenial.companyID,
      Authorization: `Bearer ${kd.xenial.accessToken}`,
    };

    $.ajax({
      url: `${kd.xenial.dmEnvironmentURL}/floor-plan/document/${kd.xenial.floorPlanDocumentID}`,
      type: "GET",
      contentType: "application/json",
      headers,
      success: (result) => {
        kd.xenial.config = result;
        if (
          !result.gla.hasOwnProperty("location") ||
          !result.gla.location.hasOwnProperty("turnTimes") ||
          result.gla.location.turnTimes.length === 0
        ) {
          kd.xenial.config.gla = defaults;
        }

        const payload = result.gla;
        Object.keys(payload).forEach((domain) => {
          kd.remove(domain);
          if (domain === "template") {
            for (let i = 0; i < payload[domain].length; ++i) {
              kd.replaceArray(domain, payload[domain][i]);
            }
          } else if (domain === "limit") {
            for (let i = 0; i < payload[domain].length; ++i) {
              kd.replaceArray(domain, payload[domain][i]);
            }
          } else {
            kd.replace(domain, payload[domain]);
          }
        });
        setTimeout(() => {
          kd.emit("location.update", {});
          callback(null, result);
        }, 100);
      },
      error: (jqXHR, textStatus, errorThrown) => {
        callback(null, { status: "error", errorThrown });
      },
      timeout: 10000,
    });
  }
};

const receive = (payload, kd) => {
  if (payload.type == "rpc") {
    kd.emit("rpc", payload);
  }
};

const send = (payload, kd) => {
  kd.emit("rpc", payload);
};

const emit = (domain, data, kd) => {
  kd.emit("push", data);
};

module.exports = {
  configure,
  receive,
  send,
  emit,
  getXConfig,
};



/** WEBPACK FOOTER **
 ** ./src/client/embed/index.js
 **/